
import { APIProvider, Map, AdvancedMarker, Pin } from '@vis.gl/react-google-maps';
export default function Mapa(props) {

  // function gotodir(e, pos) {
  //   window.open(`https://www.google.com/maps/dir/?api=1&destination=${pos.lat},${pos.lng}`, '_blank', 'noreferrer');
  // }

  return (
    <APIProvider apiKey={'AIzaSyD8zpx5in9ieAQlIYiLb3SXAvuNqr_UObU'}>
      <Map
        style={props.style}
        defaultCenter={props.center}
        defaultZoom={props.zoom}
        gestureHandling='greedy'
        disableDefaultUI
        mapId={'bf51a910020fa25a'}
      >
        {
          props.marks.map((m, im) => (
            <AdvancedMarker key={im}
              position={m.pos}
            //icon={props.icon}
            //onClick={(e) => { gotodir(e, m.pos) }}
            >
              <Pin
                background={'#0f9d58'}
                borderColor={'#006425'}
                glyphColor={'#60d98f'}
              />
            </AdvancedMarker>
          ))
        }
      </Map>
    </APIProvider>

  )
}